export const SimplifiedLogisticData = [
  {
    header: 'Safe And Secure Deliveries',
    description:
      'Our 24/7 monitored warehouse facilities ensure the security of your packages, while our advanced last-mile delivery systems provide comprehensive track and trace on your shipment’s journey to YOU.',
    src: 'cml/secure-deliveries',
  },
  {
    header: 'Faster Deliveries To Nigeria',
    description:
      'We ensure reduced delivery times for shipments to Nigeria; with our goal to ensure timely delivery, with most shipments arriving within 3 - 4 days and very soon within 24 hours .',
    src: 'cml/fast-deliveries',
  },
  {
    header: 'Robust Delivery Networks Across Nigeria',
    description:
      'Our last-mile delivery services go beyond standard coverage areas, we are committed to  reaching underserved regions across Nigeria; ensuring your wish-list items go beyond the cart and into YOUR hands. ',
    src: 'cml/robust-delivery',
  },
  {
    header: 'Exceptional Customer Service',
    description:
      'We are a breath of fresh air as every customer is important to us. We make sure that whether you are sending one item from China to Nigeria or a thousand, you are completely satisfied with our service.',
    src: 'cml/exceptional-cs',
  },
];
